export default __webpack_public_path__ + "media/images/container_bg-1396435987a5bcb0f81dad64392aaf53.png";